import { render, staticRenderFns } from "./Rides.vue?vue&type=template&id=040cb808&scoped=true"
import script from "./Rides.vue?vue&type=script&lang=js"
export * from "./Rides.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "040cb808",
  null
  
)

export default component.exports